
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sports-hub",
      function () {
        return require("private-next-pages/sports-hub.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sports-hub"])
      });
    }
  